<template>
  <div>
    <div class="card p-fluid p-mt-2">
      <DataTable
        :value="systemData_table"
        :paginator="true"
        :rows="10"
        dataKey="id"
        :rowHover="true"
        :filters="filters"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class="p-grid">
            <div class="table-header p-col-3" style="margin-left: auto">
              <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span>
            </div>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>

        <Column
          field="id"
          :header="$t('igeneral_sequence')"
          :sortable="false"
          v-if="1 == 2"
          headerStyle="width: 90px"
          >>
          <template #body="dataTable">
            <div v-if="dataTable.data.id == 0 || dataTable.data.id == ''">
              -
            </div>
            <div v-else>{{ dataTable.data.id }}</div>
          </template>
        </Column>

        <Column
          field="id"
          :header="$t('igeneral_sequence')"
          :sortable="false"
          headerStyle="width: 90px"
          >>
          <template #body="dataTable">
            {{ dataTable.index + 1 }}
          </template>
        </Column>

        <!-- <Column :header="$t('user_profile')" :sortable="false">
          <template #body="dataTable">
            <img
              class="userimg"
              :src="httpimg(dataTable.data.memb_img_main)"
              @error="replaceByDefault"
              style="vertical-align: middle"
            />
          </template>
        </Column> -->

        <Column
          field="memb_pnum"
          :header="$t('phone_number')"
          :sortable="true"
          width="25px"
        >
          <template #body="dataTable">
            {{ dataTable.data.memb_pnum }}
          </template>
        </Column>

        <Column field="memb_nme" :header="$t('imp_firstname')" :sortable="true">
          <template #body="dataTable">
            {{ dataTable.data.memb_nme }}
          </template>
        </Column>

        <Column field="memb_snme" :header="$t('imp_lastname')" :sortable="true">
          <template #body="dataTable">
            {{ dataTable.data.memb_snme }}
          </template>
        </Column>

        <Column field="memb_email" :header="$t('email')" :sortable="true">
          <template #body="dataTable">
            {{ dataTable.data.memb_email }}
          </template>
        </Column>

        <Column
          field="memb_flag"
          :header="$t('igeneral_program_status')"
          :sortable="true"
        >
          <template #body="dataTable">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-8">
                <Button
                  @click="
                    displayConfirmation = true;
                    temp = dataTable.data.id;
                    status = dataTable.data.memb_flag;
                  "
                  :label="dataTable.data.memb_flag == '1' ? 'ปกติ' : 'ยกเลิก'"
                  :class="
                    dataTable.data.memb_flag == '1'
                      ? 'p-button-rounded p-button-success'
                      : 'p-button-rounded p-button-danger'
                  "
                />
              </div>
            </div>
          </template>
        </Column>

        <Column :header="$t('controlTable')">
          <template #body="dataTable">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-8">
                <Button
                  @click="
                    systemDataModal = true;
                    editData(dataTable.data);
                    temp = dataTable.data.id;
                    systemDataMode = 'edit';
                  "
                  icon="pi pi-pencil"
                  :label="$t('editBtn')"
                  class="p-button-rounded p-button-warning"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Manage general system modal -->
    <Dialog
      :modal="true"
      :visible.sync="systemDataModal"
      :style="{ width: '660px' }"
      :header="header"
    >
      <div class="confirmation-content">
        <label>{{ $t("systemData_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-3">
          <div class="p-formgrid p-grid">
            <div class="p-field p-col-3">
              <img
                class="edituserimg"
                :src="httpimg(selectedData.memb_img_main)"
                @error="replaceByDefault"
                style="vertical-align: middle"
              />
            </div>
            <div class="p-field p-col-9" />
          </div>

          <div class="p-formgrid p-grid p-mt-3" style="margin-left: 150px">
            <div class="p-field p-col-6">
              <label for="igeneral_dataName"
                >{{ $t("imp_firstname") }}
                <span class="required-input">*</span></label
              >

              <InputText
                id="igeneral_dataName"
                type="text"
                v-model="selectedData.memb_nme"
                required="true"
                autofocus
                :class="{
                  'p-invalid':
                    error_igeneral_dataName && !selectedData.memb_nme,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_igeneral_dataName && !selectedData.memb_nme"
                >{{ $t("igeneral_dataName_validate") }}</small
              >
            </div>

            <div class="p-field p-col-6">
              <label for="igeneral_dataName"
                >{{ $t("imp_lastname") }}
                <span class="required-input">*</span></label
              >

              <InputText
                id="igeneral_dataName"
                type="text"
                v-model="selectedData.memb_snme"
                required="true"
                autofocus
                :class="{
                  'p-invalid':
                    error_igeneral_dataName && !selectedData.memb_snme,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_igeneral_dataName && !selectedData.memb_snme"
                >{{ $t("igeneral_dataName_validate") }}</small
              >
            </div>
          </div>

          <div class="p-formgrid p-grid p-mt-5">
            <div class="p-field p-col-3">
              <label for="igeneral_dataName"
                >{{ $t("phone_number") }}
                <span class="required-input">*</span></label
              >

              <InputText
                :disabled="true"
                id="igeneral_dataName"
                type="text"
                v-model="selectedData.memb_pnum"
                required="true"
                autofocus
                :class="{
                  'p-invalid':
                    error_igeneral_dataName && !selectedData.memb_pnum,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_igeneral_dataName && !selectedData.memb_pnum"
                >{{ $t("igeneral_dataName_validate") }}</small
              >
            </div>

            <div class="p-field p-col-9">
              <label for="igeneral_dataName"
                >{{ $t("email") }} <span class="required-input">*</span></label
              >

              <InputText
                id="igeneral_dataName"
                type="text"
                v-model="selectedData.memb_email"
                required="true"
                autofocus
                :class="{
                  'p-invalid':
                    error_igeneral_dataName && !selectedData.memb_email,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_igeneral_dataName && !selectedData.memb_email"
                >{{ $t("igeneral_dataName_validate") }}</small
              >
            </div>
          </div>

          <div class="p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-4">
              <label for="igeneral_dataName"
                >{{ $t("igeneral_dvdate") }}
              </label>

              <Calendar
                :disabled="true"
                dateFormat="dd/MM/yy"
                :showButtonBar="true"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2050"
                :locale="th"
                id="igeneral_dataName"
                v-model="selectedData.memb_dvdate"
                :class="{
                  'p-invalid':
                    error_igeneral_dataName && !selectedData.memb_dvdate,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_igeneral_dataName && !selectedData.memb_dvdate"
                >{{ $t("igeneral_dataName_validate") }}</small
              >
            </div>

            <div class="p-field p-col-4">
              <label for="igeneral_dataName"
                >{{ $t("igeneral_dvtime") }}
              </label>

              <Calendar
                :disabled="true"
                :timeOnly="true"
                hourFormat="24"
                :showSeconds="true"
                id="igeneral_dataName"
                v-model="selectedData.memb_dvdate"
                :class="{
                  'p-invalid':
                    error_igeneral_dataName && !selectedData.memb_dvdate,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_igeneral_dataName && !selectedData.memb_dvdate"
                >{{ $t("igeneral_dataName_validate") }}</small
              >
            </div>
          </div>

          <div class="p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-4">
              <label for="igeneral_dataName"
                >{{ $t("igeneral_rgdate") }}
              </label>

              <Calendar
                :disabled="true"
                dateFormat="dd/MM/yy"
                :showButtonBar="true"
                :monthNavigator="true"
                :yearNavigator="true"
                yearRange="2000:2050"
                :locale="th"
                id="igeneral_dataName"
                v-model="selectedData.memb_rgdate"
                :class="{
                  'p-invalid':
                    error_igeneral_dataName && !selectedData.memb_rgdate,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_igeneral_dataName && !selectedData.memb_rgdate"
                >{{ $t("igeneral_dataName_validate") }}</small
              >
            </div>

            <div class="p-field p-col-4">
              <label for="igeneral_dataName"
                >{{ $t("igeneral_rgtime") }}
              </label>

              <Calendar
                :disabled="true"
                :timeOnly="true"
                hourFormat="24"
                :showSeconds="true"
                id="igeneral_dataName"
                v-model="selectedData.memb_rgdate"
                :class="{
                  'p-invalid':
                    error_igeneral_dataName && !selectedData.memb_rgdate,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_igeneral_dataName && !selectedData.memb_rgdate"
                >{{ $t("igeneral_dataName_validate") }}</small
              >
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          v-if="selectedData != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          @click="clearData()"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          @click="saveData()"
        />
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      :header="status == '1' ? $t('ConfirmDisable') : $t('ConfirmEnable')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{
          status == "1" ? $t("ConfirmDisableSub") : $t("ConfirmEnableSub")
        }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete(temp)"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Are you sure for close this modal -->
    <Dialog
      :modal="true"
      :header="$t('ConfirmCloseModal')"
      :visible.sync="displayConfirmationCloseModal"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <span>{{ $t("ConfirmCloseModalSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmationCloseModal = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeAllModal()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "system-user",
  data() {
    return {
      keyword: "",
      systemData_table: [],
      filters: {},
      temp: null,
      status: null,
      displayConfirmation: false,
      systemDataModal: false,
      systemDataMode: "add",
      igeneral_dataName: "",
      error_igeneral_dataName: false,
      error_igeneral_dataGroupSelect: false,
      header: this.$i18n.t("systemData_modal_title_add"),
      selectedData: "",
      check_duplicate: "",
      displayConfirmationCloseModal: false,
      tempFor_displayConfirmationCloseModal: "",
    };
  },
  watch: {
    displayConfirmationCloseModal(val) {
      if (val == true) {
        this.systemDataModal = true;
      }
    },

    check_duplicate(val) {
      if (val == "duplicate") {
        this.$toast.add({
          severity: "error",
          summary: "เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ",
          detail: "มีข้อมูลนี้ในระบบแล้ว",
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: "success",
          summary: "เพิ่มข้อมูลสำเร็จ",
          detail: "ข้อมูลพื้นฐานระบบ",
          life: 3000,
        });
      }
    },
  },
  created() {
    this.initialData();
  },

  methods: {
    async initialData() {
      await this.axios
        .get(`${this.$url_service}/members/all`, {
          body: {},
        })
        .then((response) => {
          this.systemData_table = response.data[0].data;
        });
    },

    closeAllModal() {
      console.log("Close and don`t save data");
      this.systemDataModal = false;
      this.displayConfirmationCloseModal = false;
      this.clearData();
    },

    async searchSystemData() {
      console.log(this.keyword);
      await this.axios
        .get(`${this.$url_service}/shops/type/search/` + this.keyword, {
          body: {},
        })
        .then((response) => {
          this.systemData_table = response.data[0].data;
        });
      this.dataGroupSelect = null;
      //this.keyword = "";
    },

    replaceByDefault(e) {
      e.target.src = require("../../../../public/assets/pmg-userprofile.png");
    },

    async confirmDelete() {
      this.displayConfirmation = false;

      if (this.status == "1") {
        if (this.temp != "") {
          await this.axios
            .patch(`${this.$url_service}/members/${this.temp}`, [
              {
                memb_flag: "0",
              },
            ])
            .then(() => this.initialData());
          this.$toast.add({
            severity: "success",
            summary: "ปิดการใช้งานสำเร็จ",
            detail: "ข้อมูลผู้ใช้งานทั่วไป",
            life: 3000,
          });

          this.systemDataModal = false;
        }
      } else {
        if (this.temp != "") {
          await this.axios
            .patch(`${this.$url_service}/members/${this.temp}`, [
              {
                memb_flag: "1",
              },
            ])
            .then(() => this.initialData());
          this.$toast.add({
            severity: "success",
            summary: "เปิดการใช้งานสำเร็จ",
            detail: "ข้อมูลผู้ใช้งานทั่วไป",
            life: 3000,
          });

          this.systemDataModal = false;
        }
      }
    },
    httpimg(img) {
      return this.$url_image + img;
    },
    async saveData() {
      if (this.temp != "") {
        await this.axios
          .patch(
            `${this.$url_service}/members/${this.selectedData.memb_pnum}`,
            [
              {
                memb_nme: this.selectedData.memb_nme,
                memb_snme: this.selectedData.memb_snme,
                memb_email: this.selectedData.memb_email,
              },
            ]
          )
          .then(() => this.initialData());
        this.$toast.add({
          severity: "success",
          summary: "แก้ไขข้อมูลสำเร็จ",
          detail: "ข้อมูลพื้นฐาน",
          life: 3000,
        });

        this.systemDataModal = false;
      }
    },

    async editData(data) {
      this.header = this.$i18n.t("systemData_modal_title_edit");
      this.igeneral_dataName = data.memb_nme;
      this.selectedData = data;
      this.selectedData.memb_dvdate = new Date(Date.parse(this.selectedData.memb_dvdate));
      this.selectedData.memb_rgdate = new Date(Date.parse(this.selectedData.memb_rgdate));
      console.log(this.selectedData);
    },

    clearData() {
      //Edit data
      if (this.selectedData != "") {
        this.temp = null;
        this.header = this.$i18n.t("systemData_modal_title_add");
        this.displayConfirmation = false;
        this.systemDataModal = false;
        this.selectedData = "";
        this.setDefault();
        //Add data
      } else {
        this.temp = null;
        this.displayConfirmation = false;
        this.setDefault();
      }
    },

    setDefault() {
      this.igeneral_dataName = "";
    },

    async clearSearchField() {
      await this.axios
        .get(`${this.$url_service}/shops/type/all`, {
          body: {},
        })
        .then((response) => {
          this.systemData_table = response.data[0].data;
        });
      this.dataGroupSelect = null;
      this.keyword = "";
    },
  },
};
</script>

<style scoped>
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}

.userimg {
  /* background-image: url(https://i.stack.imgur.com/3keSg.png) !important; */
  background-color: #21529f;
  background-size: 54px 54px;
  border-radius: 10%;
  border: 2px solid #555;
  width: 54px;
  height: 54px;
  margin-bottom: 0px;
  margin-left: 0px;
}

.userimg:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
  cursor: pointer;
}

.edituserimg {
  /* background-image: url(https://i.stack.imgur.com/3keSg.png) !important; */
  background-color: #21529f;
  background-size: 54px 54px;
  border-radius: 10%;
  border: 2px solid #555;
  width: 125px;
  height: 125px;
  margin-bottom: -100px;
  margin-left: 0px;
}

.edituserimg:hover {
  box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
  cursor: pointer;
}

.p-dialog-footer 
{
  padding: 0px;
}

</style>
